module.exports = __webpack_public_path__ + "img/IconEC.8ce0c14f.svg";